import moment from 'moment'
import { IIFImport, generateIIF } from './quickbooksIIFBill.service'
import {
  Order,
  OrderEntry,
  QuickbooksSetting
} from '@/firestore'


function getCategoryAccount(category: string | undefined, quickBooksSetting: QuickbooksSetting) {
  if (!category) {
    return 'Unknown'
  }

  if (
    category === 'Food, Beverages & Tobacco > Beverages > Alcoholic Beverages > Wine'
    && quickBooksSetting.categorySettings.wine
  ) {
    return quickBooksSetting.categorySettings.wine
  } else if (
    category === 'Food, Beverages & Tobacco > Beverages > Alcoholic Beverages > Beer'
    && quickBooksSetting.categorySettings.beer
  ) {
    return quickBooksSetting.categorySettings.beer
  } else if (
    category.includes('Liquor & Spirits')
    && quickBooksSetting.categorySettings.liquorAndSpirits
  ) {
    return quickBooksSetting.categorySettings.liquorAndSpirits
  } else if (
    category.includes('Alcoholic Beverages')
    && quickBooksSetting.categorySettings.otherAlcohol
  ) {
    return quickBooksSetting.categorySettings.otherAlcohol
  } else if (
    category.includes('Beverages')
    && quickBooksSetting.categorySettings.nonAlcoholic
  ) {
    return quickBooksSetting.categorySettings.nonAlcoholic
  } else if (
    category.includes('Food Items')
    && quickBooksSetting.categorySettings.foodItems
  ) {
    return quickBooksSetting.categorySettings.foodItems
  } else {
    return 'Unknown'
  }
}

function getPriceString(entry: OrderEntry) {
  const totalPrice = entry.pricePerUnit ? (entry.pricePerUnit * entry.quantity) : 0

  return `$${totalPrice.toFixed(2)}`
}

function getProductsTotal(order: Order) {
  const totalPrice = order.orderEntries.reduce((acc, entry) => {
    return entry.pricePerUnit ? acc + entry.pricePerUnit : acc
  }, 0)

  return `$${totalPrice.toFixed(2)}`
}

function getProductName(entry: OrderEntry) {
  return entry.quantityType
    ? `${entry.quantity} ${entry.description} ${entry.quantityType}`
    : `${entry.quantity} ${entry.description}`
}

function getVendorAccount(vendorRepId: string, quickBooksSetting: QuickbooksSetting) {
  const vendorSetting = quickBooksSetting.vendorSettings[vendorRepId]
  return vendorSetting ? vendorSetting.quickbooksVendorName : 'No Vendor Name Found'
}

function getExpenseAccount(vendorRepId: string, quickBooksSetting: QuickbooksSetting) {
  const vendorSetting = quickBooksSetting.vendorSettings[vendorRepId]
  return vendorSetting ? vendorSetting.quickbooksExpenseAccount : 'No Expense Account Found'
}

function getInvoiceNumber(order: Order) {
  return order.invoiceNumber ? order.invoiceNumber : 'No Invoice Number Found'
}

export async function quickbooksExport(orders: Order[], quickBooksSetting: QuickbooksSetting) {
  const exports = orders.reduce((acc, order) => {
    const orderEntryObjects = order.orderEntries.map(entry =>
      ({
        trns: 'SPL',
        trnsId: '',
        trnsType: 'BILL',
        date: moment(order.datePlaced).format('MM/DD/YY'),
        account: getCategoryAccount(entry.category, quickBooksSetting),
        name: '',
        class: '',
        amount: getPriceString(entry),
        docNum: '',
        memo: getProductName(entry),
        clear: 'N',
        toprint: '',
        addr5: 'NOTHING',
        dueDate: '',
        terms: ''
        // do i need a blank string here for empty?
      } as IIFImport)
    )

    return [
      ...acc,
      {
        trns: 'TRNS',
        trnsId: '',
        trnsType: 'BILL',
        date: moment(order.datePlaced).format('MM/DD/YY'),
        account: getExpenseAccount(order.assignedCompanyId, quickBooksSetting),
        name: getVendorAccount(order.assignedCompanyId, quickBooksSetting),
        class: '',
        amount: getProductsTotal(order),
        docNum: getInvoiceNumber(order),
        memo: order.number,
        clear: 'N',
        toprint: 'N',
        addr5: '',
        dueDate: '',
        terms: ''
      } as IIFImport,
      ...orderEntryObjects
    ]
  }, [] as IIFImport[])

  await generateIIF(exports)
}
